module.exports = __webpack_public_path__ + "img/product-details-4.54b6c0b1.svg";